<template lang="html">
  <process-responses-row
    :model="model"
    :header="header"
    :cell="cell"
    :statuses="statuses"
    :loadingStatus="loadingStatus"
    @statusChange="$emit('statusChange', $event)"
    />
</template>

<script>
  export default {
    name: 'responses-row',

    props: {
      model: Object,
      header: Object,
      cell: Object,
      statuses: Array,
      loadingStatus: Boolean
    }
  }
</script>

<style lang="scss" scoped>
</style>
